import type { MemberOption } from '../lib/members'

/**
 * Whose day you are looking at.
 *
 * Hidden entirely while the household has one person, which is the rule
 * `README.md` states for the concept as a whole: "the UI never mentions the
 * concept until there is a second person". A single chip would be a control that
 * cannot do anything, on the screen the app opens on.
 *
 * Switching is a *view*, not an identity: you stay signed in as yourself, and
 * ticking a box while looking at somebody else's list writes a completion under
 * their member id. That is deliberate and it is the whole reason the member is
 * the third component of the completion id — a child with no device of their own
 * still has their own row, ticked from a parent's phone, and it converges with
 * whatever they tick themselves the day they get one.
 */
export function MemberChips({
  members,
  selected,
  onSelect,
}: {
  members: readonly MemberOption[]
  selected: string
  onSelect: (memberId: string) => void
}) {
  if (members.length < 2) return null

  return (
    <div class="member-chips" role="tablist" aria-label="Membres du foyer">
      {members.map((member) => (
        <button
          class={`member-chip ${member.id === selected ? 'active' : ''}`}
          role="tab"
          aria-selected={member.id === selected}
          onClick={() => onSelect(member.id)}
        >
          {member.displayName}
        </button>
      ))}
    </div>
  )
}
